import persistSlug from './persistSlug'
import resolveSlug from './resolveSlug'
import storedSlugRedirectPath from './storedSlugRedirectPath'

export default {
  persistSlug,
  resolveSlug,
  storedSlugRedirectPath,
}
